import script from "./RcButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcButton.vue?vue&type=script&setup=true&lang=ts"

import "./RcButton.vue?vue&type=style&index=0&id=74d2f3ea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74d2f3ea"]])

export default __exports__